export default [
  {
    label: 'Все',
    value: -1,
    filterFn: () => true,
  },
];
